
import ImageContainer from '@/views/creative/components/image-container.vue';
import VideoContainer from '@/views/creative/components/video-container.vue';
import SequenceFrameContainer from '@/views/creative/components/frame-sequence.vue';
import AudioContainer from '@/views/creative/components/audio-container.vue';

export default {
  components: {
    ImageContainer: ImageContainer,
    VideoContainer: VideoContainer,
    SequenceFrameContainer: SequenceFrameContainer,
    AudioContainer: AudioContainer
  },
  props: {
    config: Object,
    formValue: Object
  },
  data: function data() {
    return {
      visible: true,
      innerStyle: {
        width: '200px',
        height: '150px',
        maxWidth: '200px',
        maxHeight: '150px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center'
      }
    };
  },

  computed: {
    showPicture: function showPicture() {
      return [7, 8, 9, 13, 14, 16, 17, 18].indexOf(this.config.resourceType) !== -1 || this.config.resourceType === 10 && (this.config.isBatchAdd || this.formValue.cat1_id === 1 || this.formValue.cat1_id === 3) || this.config.resourceType === 11 && this.formValue.cat1_id !== 2;
    },
    showVideo: function showVideo() {
      return this.config.resourceType === 5;
    },
    showAudio: function showAudio() {
      return this.config.resourceType === 6 || this.config.resourceType === 15;
    },
    showFrame: function showFrame() {
      // 特效库中和主角库中cat1_id===2才是序列帧,
      return this.config.resourceType === 10 && this.formValue.cat1_id === 2 || this.config.resourceType === 11 && this.formValue.cat1_id === 2;
    },
    fileUrl: function fileUrl() {
      // 龙骨中展示image_url
      if (this.config.resourceType === 10 && (this.formValue.cat1_id === 1 || this.formValue.cat1_id === 3) || this.config.resourceType === 11 && this.formValue.cat1_id === 1 || this.config.resourceType === 16 || this.config.resourceType === 18) {
        return this.formValue.image_url;
      }
      return this.formValue[this.config.prop];
    },
    coverUrl: function coverUrl() {
      return this.formValue.image_url; // 目前这个字段放置的是视频封面图
    },
    previewUrls: function previewUrls() {
      return this.formValue.preview_urls || []; // 目前这个字段放置的是序列帧的预览数组
    },
    dimensionWidth: function dimensionWidth() {
      if (this.formValue.dimension === '-' || !this.formValue.dimension) return 0;
      return this.formValue.dimension.split('x')[0];
    },
    dimensionHeight: function dimensionHeight() {
      if (this.formValue.dimension === '-' || !this.formValue.dimension) return 0;
      return this.formValue.dimension.split('x')[1];
    },
    frameInnerStyle: function frameInnerStyle() {
      return {
        width: this.dimensionWidth / 2 + 'px',
        height: this.dimensionHeight / 2 + 'px'
      };
    }
  }
};